import { httpCreate } from './http';

const http = httpCreate('/srv/activity-navigation-bar');
export const activityNavigationBar = {
	getGlobal() {
		return http.get('');
	},
	/** 保存导航设置
	 * @param { String } data.webLogo //logo
	 * @param { String } data.webName	//网站名称
	 * @param { String } data.link	//链接
	 * @param { Number } data.navigationSwitch	//开关 0 关 1 开
	 */
	saveGlobal(data) {
		return http.post('', data);
	},
	/** 保存导航设置
	 * @param { Number | String } id //直播间id
	 * @param { String } data.webLogo //logo
	 * @param { String } data.webName	//网站名称
	 * @param { String } data.link	//链接
	 * @param { Number } data.navigationSwitch	//开关 0 关 1 开
	 */
	save(id, data) {
		return http.post(`/${id}`, data);
	},
	saveTemplate(data) {
		return http.post('/template', data);
	},
	deleteTemplate(id) {
		return http.delete(`/template/${id}`);
	},
	getTemplateList(params) {
		return http.get('/template', { params });
	},
};
